import { GenericInputSwitchStyle } from './styles';

const GenericInputSwitch = ({ ...props }: any) => {
  return <GenericInputSwitchStyle {...props} />;
};

export default GenericInputSwitch;
